import { api } from './api'

export const apiClient = {
  get: (url: string, params?: any) => {
    if (params && Object.keys(params).length > 0) {
      // Filter out undefined, null, and empty string values, but keep false and 0
      const filteredParams: any = {}
      Object.keys(params).forEach(key => {
        if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
          filteredParams[key] = params[key]
        } else if (params[key] === false || params[key] === 0) {
          // Include false and 0 values explicitly
          filteredParams[key] = params[key]
        }
      })
      
      return api.get(url, { params: filteredParams })
    }

    return api.get(url)
  },
  post: (url: string, data?: any) => api.post(url, data),
  put: (url: string, data?: any) => api.put(url, data),
  patch: (url: string, data?: any) => api.patch(url, data),
  delete: (url: string) => api.delete(url)
}
